export { default } from '@material-ui/core/InputBase';
